import React, { useImperativeHandle, forwardRef, useRef } from 'react';
import Button from '../../atoms/Button';
import Icon from '../../atoms/Icon';
import Input from '../../atoms/Input';
import Form from '../Form';
const SearchIcon = () => (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" },
    React.createElement("circle", { cx: "11", cy: "11", r: "8" }),
    React.createElement("line", { x1: "21", y1: "21", x2: "16.65", y2: "16.65" })));
const SearchInput = forwardRef(function SearchInput({ onSubmit, icon, 'aria-label': ariaLabel = 'search', testId = 'store-search-input', ...otherProps }, ref) {
    const inputRef = useRef(null);
    const formRef = useRef(null);
    const handleSubmit = (event) => {
        event.preventDefault();
        if (inputRef.current?.value !== '') {
            onSubmit(inputRef.current.value);
        }
    };
    useImperativeHandle(ref, () => ({
        inputRef: inputRef.current,
        formRef: formRef.current,
    }));
    return (React.createElement(Form, { ref: formRef, "data-store-search-input": true, "data-testid": testId, onSubmit: handleSubmit, role: "search" },
        React.createElement(Input, Object.assign({ ref: inputRef, "aria-label": ariaLabel }, otherProps)),
        React.createElement(Button, { type: "submit", "aria-label": "Submit Search" },
            React.createElement(Icon, { component: icon ?? React.createElement(SearchIcon, null) }))));
});
export default SearchInput;
//# sourceMappingURL=SearchInput.js.map